module.exports = __webpack_public_path__ + "static/media/Vibrava_gaussian2.73e34efa.png";